/**
 * Enum used to define system values e.g. values automatically provided by the system
 */
export enum NodeMaterialSystemValues {
    /** World */
    World = 1,
    /** View */
    View = 2,
    /** Projection */
    Projection = 3,
    /** ViewProjection */
    ViewProjection = 4,
    /** WorldView */
    WorldView = 5,
    /** WorldViewProjection */
    WorldViewProjection = 6,
    /** CameraPosition */
    CameraPosition = 7,
    /** Fog Color */
    FogColor = 8,
    /** Delta time */
    DeltaTime = 9
}